import React, { useState } from "react";
import CustomTabs from "../../global/components/CustomTabs/CustomTabs";
import ShowAll from "./components/ShowAll/ShowAll";
import Unmapped from "./components/Unmapped/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const tabConfig = [
  { label: "Existing Project" },
  { label: "Un Mapped Project" },
];

const Team = (_props: CustomProps) => {
  const [tabValue, setTabValue] = useState<string>("Existing Project");

  function getContent() {
    switch (tabValue) {
      case "Existing Project":
        return <ShowAll type={"Existing Project"} />;
      case "Un Mapped Project":
        return <Unmapped type={"Un Mapped Project"} />;
      default:
        return null;
    }
  }

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <div className="mb-4 shrink-0">
        <h1 className="text-2xl font-bold tracking-tight text-[#111827]">
          Aggregator Api List
        </h1>
        <p className="mt-1 text-sm text-[#6B7280]">
          Map portal projects (Magic Bricks MB_, Housing HC_, 99 Acres AC_) to CRM
          projects once — then leads flow to All Leads automatically.
        </p>
      </div>
      <div className="mb-3 shrink-0">
        <CustomTabs
          changeValue={setTabValue}
          selected={tabValue}
          tabConfig={tabConfig}
        />
      </div>
      <div className="min-h-0 flex-1 overflow-auto">{getContent()}</div>
    </div>
  );
};

export default Team;
